import React from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

class SelectFieldMultiSelect extends React.Component {
    state = {
        values: [],
    }

    handleChange = (event, index, value) => {
        return this.props.input.onChange(value);
    }

    renderMenuItem = (choice) => {
        const {
            optionText,
            optionValue,
            translate,
            translateChoice,
        } = this.props;
        const { values } = this.state;

        let choiceName;

        if (React.isValidElement(optionText)) {
            choiceName = React.cloneElement(optionText, { record: choice });
        } else if (typeof optionText === 'function') {
            choiceName = optionText(choice);
        } else {
            choiceName = choice[optionText];
        }

        return (
            <MenuItem
                key={ choice[optionValue] }
                checked={ values && utils.includes(values, choice) }
                value={ choice[optionValue] }
                primaryText={ translateChoice ? translate(choiceName, { _: choiceName }) : choiceName }
            />
        );
    }

    render() {
        const {
            choices,
            className,
            floatingLabelFixed = false,
            fullWidth = false,
            input,
            label,
            meta: {
                touched,
                error,
            },
            placeholder,
            resource,
            source,
            translate,
        } = this.props;

        return (
            <SelectField
                className={ className }
                multiple={ true }
                value={ input.value }
                onChange={ this.handleChange }
                errorText={ touched && error }
                floatingLabelText={
                    label ? <FieldTitle label={ label } source={ source } resource={ resource } /> : false
                }
                hintText={ placeholder ? translate(placeholder) : null }
                fullWidth={ fullWidth }
                floatingLabelFixed={ floatingLabelFixed }
            >
                {
                    choices.map(this.renderMenuItem)
                }
            </SelectField>
        );
    }
}

SelectFieldMultiSelect.defaultProps = {
    choices: [],
    onChange: () => {
        return true;
    },
    optionText: 'name',
    optionValue: 'id',
    translateChoice: true,
};

SelectFieldMultiSelect.propTypes = {
    choices: PropTypes.array.isRequired,
    className: PropTypes.string,
    floatingLabelFixed: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    onChange: PropTypes.func,
    optionText: PropTypes.string,
    optionValue: PropTypes.string,
    placeholder: PropTypes.string,
    resource: PropTypes.string,
    source: PropTypes.string,
    translate: PropTypes.func.isRequired,
    translateChoice: PropTypes.bool.isRequired,
};

export default translate(SelectFieldMultiSelect);



// WEBPACK FOOTER //
// ./src/components/input/SelectFieldMultiSelect/SelectFieldMultiSelect.js